import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; // eslint-disable-line

const Container = styled.div`
  ${tw`
    max-w-screen-md
    mx-auto
    px-4
    py-8
    text-gray-800
    text-lg
    leading-relaxed
  `}
`;

export default function ContentText({ htmlContent }) {
  return (
    <Container>
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </Container>
  );
}
